// extracted by mini-css-extract-plugin
export var radioInputRow = "y_s8";
export var radioInputColumn = "y_s9";
export var inputOptionRow = "y_qq";
export var inputOptionColumn = "y_qr";